import AuthManager from "./AuthManager";
import AppSettings from "../Settings/AppSettings";

const HELP_FALLBACK_URL = "https://help.compatio.ai/";

export const buildHelpUrl = (samsTokenOverride?: string): string => {
  const samsSsoRoot = AppSettings.SAMS_SSO_URL?.split("/landing")[0];
  const samsToken = samsTokenOverride ?? AuthManager.getSamsToken();
  if (samsSsoRoot && samsToken) {
    return `${samsSsoRoot}/launchHelpDesk?token=${samsToken}`;
  }
  return HELP_FALLBACK_URL;
};

export const hasWorkspaceAccess = (): boolean => {
  const parties = AuthManager.getAuthUser()?.profile?.parties;
  return Array.isArray(parties) && parties.length > 0;
};
